import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'workers_are_not_rotated_between_tasks_reduce_exposure'

export const dataPointDefinition = {
  retracedId: 'workers_are_not_rotated_between_tasks_reduce_exposure',
  name: 'Workers are not rotated between tasks to reduce exposure to repetitive tasks',
  description: 'If the facility does not have repetitive tasks, answer Not Applicable.',
  meta: {
    slcpMeta: {
      key: 'hs-wor-46x',
      number: 'HS-WOR-23-2',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: 'hs-wor-44',
      optionList: 'xna',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-33,Yes',
      machineShowHide: '[2],hs-33,1',
      completionCondition: 'any ms',
    },
    multiSelectKey: 'hs-wor-44',
  },
  fieldTypeId: 'MULTI_SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'xna',
      name: 'xna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'string',
          enum: ['xna'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-wor-46x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31870,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
